// Numbers
export const [DD_SAMPLE_RATE, DD_REPLAY_SAMPLE_RATE] = [
  import.meta.env.VITE_DATADOG_SAMPLE_RATE,
  import.meta.env.VITE_DATADOG_REPLAY_SAMPLE_RATE,
].map((value) => (value ? parseNumber(value) : undefined));

// Booleans
export const [
  IS_DATADOG_ACTIVE,
  WONDERWALL_FEATURE_FLAG,
  isProgramCompletionActive,
  isLearnActionV4Active,
  useLearnActionClick,
  PAL_SDK_ENABLED,
  USE_LL_EXTENDED_SEEK,
] = [
  import.meta.env.VITE_IS_DATADOG_ACTIVE,
  import.meta.env.VITE_WONDERWALL_FEATURE_FLAG,
  import.meta.env.VITE_IS_PROGRAM_COMPLETION_ACTIVE,
  import.meta.env.VITE_IS_LEARN_ACTION_V4_ACTIVE,
  import.meta.env.VITE_USE_LEARN_ACTION_CLICK,
  import.meta.env.VITE_PAL_SDK_ENABLED,
  import.meta.env.VITE_USE_LL_EXTENDED_SEEK,
].map((value) => (value ? parseBoolean(value) : false));

export const LL_EXTENDED_SEEK_CHANNELS = new Set(
  (import.meta.env.VITE_LL_EXTENDED_SEEK_CHANNELS || '')
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean),
);

export function parseBoolean(value: string) {
  return value === 'true';
}

export function parseNumber(value: string) {
  const parsedValue = Number.parseFloat(value);

  if (Number.isNaN(parsedValue)) return undefined;
  return parsedValue;
}
